module.exports = __webpack_public_path__ + "static/kruthika-79b9fcdaf0f3db639c9bd8ca0bdaca5b.jpg";